import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LIVE_CHAT_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { buildThreadPausedOnGenericChannelMessage } from 'conversations-message-history/thread-paused-on-generic-channel-message/operators/buildThreadPausedOnGenericChannelMessage';
import { getAgentToVisitorChannelName, getThreadId } from 'conversations-thread-data/thread-details/public/operators';
import { publishMessageWithErrorHandling } from 'conversations-thread-view/publish-message-feature/public/actions/publishMessageWithErrorHandling';
// @ts-expect-error module not typed
import { getFocusedThreadDetails } from 'conversations-thread-view/thread-details/selectors/getFocusedThreadDetails';
import { useDispatch, useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export function CloseLiveChatButton({
  onSelectedChange,
  handleFirstClick
}) {
  const dispatch = useDispatch();
  const threadDetails = useSelector(getFocusedThreadDetails);
  const handleCloseLiveChat = () => {
    handleFirstClick === null || handleFirstClick === void 0 || handleFirstClick('CloseLiveChatButton');
    dispatch(publishMessageWithErrorHandling({
      channel: getAgentToVisitorChannelName(threadDetails),
      message: buildThreadPausedOnGenericChannelMessage({
        isPausedOn: LIVE_CHAT_GENERIC_CHANNEL_ID
      }),
      threadId: `${getThreadId(threadDetails)}`
    }));
    onSelectedChange('email');
  };
  return /*#__PURE__*/_jsx(Button, {
    size: "extra-small",
    "data-test-id": "close-live-chat-button",
    use: "tertiary-light",
    onClick: handleCloseLiveChat,
    marginInline: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.tabbed-editor.close-live-chat.button"
    })
  });
}
CloseLiveChatButton.displayName = 'CloseLiveChatButton';